import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { DashboardComponent } from './portal/dashboard/dashboard.component';
import { NotFoundComponent } from './portal/miscellaneous/not-found/not-found.component';

const routes: Routes = [{
  path: 'o/:oid',
  component: PagesComponent,
  children: [
    {
      path: 'reports',
      loadChildren: () => import('./portal/reports/reports.module')
        .then(m => m.ReportsModule),
    },
    {
      path: 'dashboard',
      component: DashboardComponent
    },
    {
      path: '**',
      component: NotFoundComponent,
    },
  ],
},
{
  path: 'g/:gid',
  component: PagesComponent,
  children: [
    {
      path: 'reports',
      loadChildren: () => import('./portal/reports/reports.module')
        .then(m => m.ReportsModule),
    },
    {
      path: 'dashboard',
      component: DashboardComponent
    },
    {
      path: '**',
      component: NotFoundComponent,
    },
  ],
},
{
  path: '',
  component: PagesComponent,
  children: [
    {
      path: 'manage-profile',
      loadChildren: () => import('./portal/manage-profile/manage-profile.module')
        .then(m => m.ManageProfile),
    },
    {
      path: '**',
      component: NotFoundComponent,
    },
  ],
}
];

const config: ExtraOptions = {
  useHash: false,
  paramsInheritanceStrategy: "always"
};

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {
}
